import React from "react";
import classNames from "classnames";
import css from "./style.scss";
import Modal from "components/base/Modal";
import {
  closePopup,
  getPopupRegistration,
  openPopup,
  Priority
} from "app/PopupHolder";

const FullAccessRequiredModal = ({ onClose }) => {

  return (
    <Modal
      isOpen={true}
      isCloseButton={false}
      uniqId="FullAccessRequiredModal"
      borderRadius="12px"
      zIndex={1000}
      modalClassName={css.fullAccessRequiredModal}
      className={classNames(css.clsClickToDialModals)}
      onClose={onClose}
    >
      <div className={css.clsWrapper}>
        <div className={css.clsMain}>
          <div className={css.clsContent}>
            <div className={css.clsTitle}>
              <span>Full Access Required</span>
            </div>
            <div className={css.clsText}>
              Dialing features require Full Access Team Member<br />
              permissions. Please contact your Primary Account<br />
              Holder to request access.
            </div>
          </div>
        </div>
        <div className={css.clsBtnWrapper}>
          <button className={css.closeBtn} onClick={onClose}>
            <span className={css.closeBtnTxt}>Close</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

const registrationId = getPopupRegistration(FullAccessRequiredModal);

FullAccessRequiredModal.open = (props = {}) => openPopup(registrationId, { ...props, priority: Priority.HIGHEST  });
FullAccessRequiredModal.close = () => closePopup({ popup: registrationId });

export default FullAccessRequiredModal;
